import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useMerchandisingPrograms = () => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['merchandisingPrograms'],
    queryFn: async () => {
      const response = await axios.get(HOST + '/api/dealer-portal/merchandising-programs');
      return response.data;
    },
    staleTime: 0,
    throwOnError: errorMessage,
  });
  return query;
};
